// extracted by mini-css-extract-plugin
export var modal = "_kq-0";